import { Attribute, Relationship, Resource } from 'json-api';
import { Translatable } from 'src/app/translation/translatable';
import { AtomResource } from '../classes/atom-resource';
import { Country } from './country.resource';
import { Enum } from './enum.resource';

@Resource({
  type: 'langs',
})
export class Lang extends AtomResource {
  @Attribute() name?: Translatable;
  @Attribute() default?: boolean;
  @Attribute() direction?: 'ltr' | 'rtl';

  @Relationship() countries?: Country[];
  @Relationship() enumdirection?: Enum;
}
